/** Tenant admins may pick any agency in the tenant; an agency admin manages only their own. */
export function canPickAgency(user) {
  return !!user?.roles?.some((r) => r === "ADMIN" || r === "GLOBAL_ADMIN");
}

/** The agency a page opens on: the user's own agency, else (tenant admins only) the first one. */
export function defaultAgencyId(agencies, user) {
  const own = agencies.find((a) => a.id === user?.agencyId);
  if (own) return own.id;
  return canPickAgency(user) && agencies.length > 0 ? agencies[0].id : null;
}

